import API from '@/services/api.js'
import { mapActions } from 'vuex'

const Notifications = {

  methods: {
    ...mapActions('currentuser', ['setNotifications']),

    notificationIcon(type) {
      switch (type) {
        case 'reminder':
          return 'mdi-reminder'
        case 'urgent':
          return 'mdi-alert-octagram'
        case 'confirmation':
          return 'mdi-check-circle'
        default:
          return 'mdi-bell-outline'
      }
    },
    async loadNotifications() {
      await API.listNotifications({
        startAt: 0,
        pageSize: 100,
        sortBy: 'sentTime',
        sortDesc: true,
        search: ''
      })
        .then(response => {
          this.setNotifications(response.data.rows)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },

    async notificationRoute(noteId, type, id) {
      await API.readNotifications({data: {id: noteId}})
      await this.loadNotifications()
      switch (type) {
        case 'Application':
          if (this.$route && this.$route.name === 'Application') {
            return
          }
          this.$nextTick(() => {
            this.$router.push({ name: 'Application', params: { id } })
          })
          break
        case 'DistanceOrder':          
          if (this.$route && this.$route.name === 'OrderDetail') {
            return
          }
          this.$nextTick(() => {
            this.$router.push({ name: 'OrderDetail', params: { id } })
          })
          break
        default:
          return ''
      }
    }
  }

}

export default Notifications
